'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var LabelParts = require('../common/LabelParts');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var textHelper = require('../../helper/util').Text;
var CheckIcon = require('../common/CheckIcon');
var RadioIcon = require('../common/RadioIcon');
var versionHelper = require('../../helper/versionHelper');
var util = require('../../helper/util');


/**
 * 表单组件
 */

var FormType = {NONE: 0, INPUT: 1, RADIO: 2, RADIO_SELECT: 3, CHECK: 4, CHECK_SELECT: 5, COMBO: 6, AREA: 7};

var CheckOrRadioItem = React.createClass({
  render: function () {
    var style = this.props.style;
    var text = styleHelper.getText(this.props) || styleHelper.getPropertyValue(this.props, 'context');
    var content = textHelper.delimitText(text, textHelper.DM_COMMA);
    var titleStyle = {
      width: this.props.titleWidth,
      height: style.height,
      lineHeight: style.height + 'px',
      position: 'absolute'
    };
    var iconStyle = {left: 0, top: (style.height - 14) / 2, size: 14, isChecked: this.props.isChecked};
    iconStyle.isSelected = iconStyle.isChecked;
    return (
      <div style={style}>
        <label style={titleStyle}>{this.props.title}</label>
        <div style={{left: this.props.titleWidth + 4, position: 'absolute'}}>
          {
            content.map(function (item, index) {
              var labelStyle = {
                left: 18,
                top: 0,
                lineHeight: (this.props.height || style.height) + 'px',
                textDecoration: 'inherit',
                position: 'absolute',
                height: style.height,
                width: 'auto',
                whiteSpace: 'nowrap'
              };
              return (
                <div key={index} ref={'item_' + index} style={{position: 'absolute'}}>
                  {
                    this.props.type === 'check' && <CheckIcon {...iconStyle}/>
                  }
                  {
                    this.props.type === 'radio' && <RadioIcon {...iconStyle}/>
                  }
                  <label style={labelStyle}>{item}</label>
                </div>
              );
            }, this)
          }
        </div>
      </div>
    );
  },

  componentDidMount: function () {
    this.doAdjustItemPoint();
  },
  doAdjustItemPoint: function () {
    var i = 0;
    var dom;
    var k;
    var left = 0;
    var w;
    var tx;
    while (true) {
      k = this.refs['item_' + i];
      i++;
      if (k) {
        dom = ReactDOM.findDOMNode(k);
        $(dom).css({left: left});
        tx = dom.children[1];
        w = tx.clientWidth + 18;
        left += (w + 6);
      } else {
        break;
      }
    }
  }
});

var ComboFormItem = React.createClass({
  render: function () {
    var style = this.props.style;
    var contentStyle = {
      left: this.props.titleWidth + 4,
      top: 0,
      position: 'absolute',
      height: style.height
    };
    var titleStyle = {
      lineHeight: style.height + 'px',
      height: style.height,
      width: this.props.titleWidth,
      position: 'absolute'
    };
    return (
      <div style={style}>
        <label style={titleStyle}>{this.props.title}</label>
        <div style={contentStyle}>
          <canvas ref="ctx" style={{width: '100%', height: '100%', position: 'absolute', zIndex: 0}}/>
          <label ref="context" style={{
            position: 'absolute',
            zIndex: 1,
            height: style.height,
            lineHeight: titleStyle.lineHeight,
            left: 2,
            overflow: 'hidden'
          }}>{this.props.context}</label>
        </div>
      </div>
    );
  },

  componentDidMount: function () {
    this.doPaint();
    $(ReactDOM.findDOMNode(this.refs.context)).css({width: ReactDOM.findDOMNode(this.refs.ctx).width - 22});
  },

  doPaint: function () {
    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
    var w = ReactDOM.findDOMNode(this).clientWidth;
    var g = ctx.getContext('2d');
    var w = w - this.props.titleWidth - 4;
    var h = ctx.clientHeight;

    w = Math.round(w * (this.props.widthRadio || 100) / 100);

    ctx.height = h;
    ctx.width = w;
    $(ctx).css({width: w, height: h});
    g.clearRect(0, 0, w, h);
    g.strokeStyle = this.props.borderColor || '#444';
    g.fillStyle = this.props.backgroundColor || '#fff';

    g.beginPath();
    g.rect(0, 0, w - 16, h);
    g.closePath();
    g.fill();


    g.beginPath();
    g.rect(0.5, 0.5, w - 1, h - 1);
    g.moveTo(w - 16.5, 0);
    g.lineTo(w - 16.5, h);
    g.closePath();
    g.stroke();

    g.beginPath();
    g.fillStyle = '#444';
    g.moveTo(w - 12.5, (h - 4) / 2);
    g.lineTo(w - 4.5, (h - 4) / 2);
    g.lineTo(w - 8.5, (h + 4) / 2);
    g.closePath();
    g.fill();

  }
});
//
var InputOrTextAreaFormItem = React.createClass({
  render: function () {
    var style = this.props.style;
    var titleStyle = {
      width: this.props.titleWidth,
      height: style.height,
      lineHeight: this.props.type === 'input' ? style.height + 'px' : '24px',
      position: 'absolute'
    };
    var contentStyle = {
      borderWidth: 1,
      borderStyle: 'solid',
      position: 'absolute',
      borderColor: this.props.borderColor,
      backgroundColor: this.props.backgroundColor,
      width: (this.props.widthRadio || 100) + '%',
      height: style.height,
      lineHeight: titleStyle.lineHeight,
      left: this.props.titleWidth + 4,
      textDecoration: 'inherit'
    };
    return (
      <div style={style}>
        <label style={titleStyle}>{this.props.title}</label>
        <div ref="content" style={contentStyle}>
          <label>{this.props.context}</label>
        </div>
      </div>
    );
  },
  doAdjust: function () {
    var w = ReactDOM.findDOMNode(this).clientWidth;
    w -= (this.props.titleWidth + 4);
    w = w * (this.props.widthRadio || 100) / 100;
    $(ReactDOM.findDOMNode(this.refs.content)).css({width: w});
  },

  componentDidMount: function () {
    this.doAdjust();
  }
});

var Form = React.createClass({

  _parseItemText: function (text) {

    var resultObj = {
      title: '',
      content: '',
      type: FormType.INPUT,
      width: 100
    };

    var titleIndex = text.indexOf(',');
    var lastIndex = text.lastIndexOf(',');
    var configText;
    var number;

    if (titleIndex === -1) {
      resultObj.title = text.trim();
      return resultObj;
    }


    resultObj.title = text.substring(0, titleIndex).trim();

    if (text.charAt(text.length - 1) === '=') {
      resultObj.type = FormType.AREA;
      resultObj.content = text.substring(titleIndex + 1, text.length - 1);
      return resultObj;
    }

    if (lastIndex === -1 || lastIndex === titleIndex) {
      resultObj.content = text.substring(titleIndex + 1, text.length).trim();
      if (resultObj.content === '=') {
        resultObj.type = FormType.AREA;
        resultObj.content = '';
      }

      return resultObj;
    }

    resultObj.content = text.substring(titleIndex + 1, lastIndex).trim();
    configText = text.substring(lastIndex + 1, text.length).trim();

    if (configText) {
      number = parseInt(configText, 10);
      if (number == configText) {
        if (number < 30) {
          number = 30
        } else if (number > 100) {
          number = 100;
        }
        resultObj.width = number;
      } else {
        if (configText.charAt(0) === 'v') {
          configText = configText.substring(1, configText.length);
          number = parseInt(configText, 10);
          if (number == configText) {
            resultObj.width = number;
          }
          resultObj.type = FormType.COMBO;
        } else if (configText === '[]') {
          resultObj.type = FormType.CHECK;
        } else if (configText === '[x]') {
          resultObj.type = FormType.CHECK_SELECT;
        } else if (configText === '()') {
          resultObj.type = FormType.RADIO;
        } else if (configText === '(o)') {
          resultObj.type = FormType.RADIO_SELECT;
        } else {
          resultObj.content = text.substring(titleIndex + 1, text.length).trim();
        }
      }
    }
    return resultObj;
  },

  _parseText: function () {
    var resultArray = [];
    var textArray = this.props.text.split('\n');

    textArray.forEach(function (text) {
      resultArray.push(this._parseItemText(text.trim()))
    }.bind(this));

    return resultArray;
  },

  _getTitleWidth: function (itemArray) {
    var width = 0;
    var size;

    itemArray.forEach(function (data) {
      size = data.title ? AutoSizeHelper.getComAutoSize(this.props, data.title) : 0;

      if (size.width > width) {
        width = size.width;
      }

    }.bind(this));

    return width;
  },

  render: function () {
    var itemArray = this._parseText();

    var backgroundStyle = {
      width: '100%',
      height: '100%'
    };

    var titleWidth = this._getTitleWidth(itemArray);
    var self = this;

    if (titleWidth) {
      titleWidth += 4;
    }
    
    return (<div style={backgroundStyle}>
      {
        itemArray.map(function (itemData, index) {
          var baseStyle;
          //处理老版本表单组件不显示问题
          var area;
          if(versionHelper.isPageVersionLowerThan4_5()) {
            var links = self.props.links.link;
            area = links[index].area.coords;
          } else {
            area = {};
            var h = styleHelper.getHeight(self.props);
            var gap = this.props.gap;
            var count = itemArray.length;
            area.width = styleHelper.getWidth(self.props);
            area.height = (h - gap * (count - 1)) / count;
            area.left = 0;
            area.top = index * (area.height + gap);
          }
          baseStyle = $.extend({}, styleHelper.builderTextStyle(this.props), {
            position: 'absolute',
            height: area.height,
            width: styleHelper.getWidth(this.props),
            top: area.top,
            textDecoration: 'inherit'
          });
          if ([FormType.CHECK, FormType.CHECK_SELECT, FormType.RADIO, FormType.RADIO_SELECT].indexOf(itemData.type) !== -1) {
            return (<CheckOrRadioItem {...{
              type: [FormType.CHECK, FormType.CHECK_SELECT].indexOf(itemData.type) !== -1 ? 'check' : 'radio',
              title: itemData.title,
              context: itemData.content,
              titleWidth: titleWidth,
              isChecked: (itemData.type === FormType.CHECK_SELECT) || (itemData.type === FormType.RADIO_SELECT),
              style: baseStyle
            }}/>);
          } else if (itemData.type === FormType.COMBO) {
            return (<ComboFormItem
                {...{
                  title: itemData.title,
                  context: itemData.content,
                  titleWidth: titleWidth,
                  style: baseStyle,
                  widthRadio: itemData.width,
                  borderColor: this.props.borderColor,
                  backgroundColor: this.props.color
                }}
            />);
          } else {
            return (
                <InputOrTextAreaFormItem
                    {...{
                      title: itemData.title,
                      context: itemData.content,
                      titleWidth: titleWidth,
                      style: baseStyle,
                      widthRadio: itemData.width,
                      borderColor: this.props.borderColor,
                      backgroundColor: this.props.color,
                      type: itemData.type === FormType.INPUT ? 'input' : 'textArea'
                    }}
                />
            );
          }
        }.bind(this))
      }
    </div>);
  }
});

module.exports = Form;



// WEBPACK FOOTER //
// ./src/views/Components/Form.jsx